import React, { useState } from 'react';
import axios from 'axios';
import { Modal, Box, Button, TextField, Typography } from '@mui/material';

export const SendEmailModal = ({ open, handleClose, company }) => {
    const [recipientEmail, setRecipientEmail] = useState('');
    const [ccEmail, setCcEmail] = useState('');
    const [emailContent, setEmailContent] = useState();

    const handleSendEmail = async () => {
        if (!recipientEmail) {
            alert("Recipient email is required.");
            return;
        }
        // Set loading indicator or disabled state if needed
        try {
            const response = await axios.post('/api/send-invoice-email/', {
                enquiry_id: company.id,
                recipient_email: recipientEmail,
                cc_email: ccEmail,
                email_content: emailContent,
            });
            alert(response.data.message);
            handleClose(); // Close modal after successful send
        } catch (error) {
            const errorMessage = error.response?.data?.error || 'Failed to send email.';
            alert(errorMessage);
        }
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box 
                sx={{ 
                    padding: 4, 
                    width: 400, 
                    backgroundColor: 'white', 
                    borderRadius: 2, 
                    boxShadow: 3,
                    position: 'absolute', 
                    top: '50%', 
                    left: '50%', 
                    transform: 'translate(-50%, -50%)' // Centers the modal
                }}
            >
                <Typography variant="h6" gutterBottom>Send Invoice Email</Typography>
                <TextField
                    label="Recipient Email"
                    fullWidth
                    value={recipientEmail}
                    onChange={(e) => setRecipientEmail(e.target.value)}
                    margin="normal"
                    sx={{ border: '2px solid orange', borderRadius: 1 }} // Orange border for TextField
                />
                <TextField
                    label="CC Email (optional)"
                    fullWidth
                    value={ccEmail}
                    onChange={(e) => setCcEmail(e.target.value)}
                    margin="normal"
                    sx={{ border: '2px solid orange', borderRadius: 1 }} // Orange border for TextField
                />
                <TextField
                    label="Email Content"
                    fullWidth
                    multiline
                    rows={4}
                    value={emailContent}
                    onChange={(e) => setEmailContent(e.target.value)}
                    margin="normal"
                    sx={{ border: '2px solid orange', borderRadius: 1 }} // Orange border for TextField
                />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
                    <Button onClick={handleClose} color="secondary">Cancel</Button>
                    <Button onClick={handleSendEmail} variant="contained" color="primary" sx={{ marginLeft: 1 }}>
                        Send
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};